import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Silhouette of a person's head",
  src: "https://ionicframework.com/docs/img/demos/avatar.svg"
}, null, -1)

import BookingDashboard from '@/components/booking/BookingDashboard.vue';
import BookingForm from '@/components/booking/BookingForm.vue';
import { IonContent, IonPage, IonModal, IonHeader, IonToolbar, IonButton, IonButtons, IonFab, IonFabButton, IonIcon, IonFooter, IonAvatar } from '@ionic/vue';
import { OverlayEventDetail } from '@ionic/core/components';
import { add } from 'ionicons/icons';
import { onUpdated, ref } from 'vue';
import { useAuth } from '@/composables/auth';
import { useWorkplace } from '@/composables/workplace';
import { useIonRouter } from '@ionic/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const ionRouter = useIonRouter();
const { getUserInformation, logout } = useAuth();
const { fetchLatestBookedWorkplaces, resetWorkplaceState} = useWorkplace();
const modal = ref();

const confirm = async () => {
  await fetchLatestBookedWorkplaces();
  modal.value.$el.dismiss('confirm');
};

onUpdated(async () => {
  if (!localStorage.getItem('token')) {
    return;
  }

  await getUserInformation();
  await fetchLatestBookedWorkplaces();
});

const handleLogoutClick = async () => {
  await logout();
  resetWorkplaceState();
  ionRouter.push('/login');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), { color: "transparent" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonAvatar), {
                    class: "account-avatar",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleLogoutClick()), ["prevent"]))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(BookingDashboard),
          _createVNode(_unref(IonModal), {
            ref_key: "modal",
            ref: modal,
            trigger: "open-modal"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonHeader), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonToolbar), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButtons), { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            strong: true,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (confirm())),
                            color: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Done")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonContent), null, {
                default: _withCtx(() => [
                  _createVNode(BookingForm)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }),
      _createVNode(_unref(IonFooter), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonFab), {
            edge: true,
            horizontal: "center",
            vertical: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonFabButton), {
                id: "open-modal",
                color: "warning"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(add) }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})